import React, { useState } from 'react';
import { PanTool, DirectionsWalk, BackHand, EmojiPeople, IceSkating, Person, TextFields, Checkroom, Accessibility, PhotoCamera, CameraAlt, Block } from '@mui/icons-material';
import './HelpCenter.css';
import Hands from './hands';
import Feet from './feet';
import Leg from "./leg";
import Arms from "./arms";
import WeirdPeople from "./WeirdPeople";
import WeirdWritings from "./WeirdWritings";
import WeirdClothing from "./WeirdClothing";
import Body from "./Body";
import Photo from "./Photo";
import Selfie from "./Selfie";
import Nswf from "./Nswf";
import Environment from "./Environment";

const L1HELP = () => {
  const [activeTab, setActiveTab] = useState('hands');
  const [enlargedImage, setEnlargedImage] = useState(null);

  const handleImageClick = (imageSrc) => {
    setEnlargedImage(imageSrc);
  };

  const handleCloseModal = () => {
    setEnlargedImage(null);
  };

  const tabs = {
    hands: {
      title: 'Hands',
      icon: <PanTool />,
      component: <Hands onImageClick={handleImageClick} />
    },
    feet: {
      title: 'Feet', 
      icon: <IceSkating />,
      component: <Feet onImageClick={handleImageClick} />
    },
    legs: {
      title: 'Legs',
      icon: <DirectionsWalk />,
      component: <Leg onImageClick={handleImageClick} />
    },
    arms: {
      title: 'Arms',
      icon: <EmojiPeople />,
      component: <Arms onImageClick={handleImageClick} />
    },
    weirdpeople: {
      title: 'People',
      icon: <Person />,
      component: <WeirdPeople onImageClick={handleImageClick} />
    },
    weirdwritings: {
      title: 'Writings',
      icon: <TextFields />,
      component: <WeirdWritings onImageClick={handleImageClick} />
    },
    weirdclothing: {
      title: 'Clothing',
      icon: <Checkroom />,
      component: <WeirdClothing onImageClick={handleImageClick} />
    },
    body: {
      title: 'Body',
      icon: <Accessibility />,
      component: <Body onImageClick={handleImageClick} />
    },
    photo: {
      title: 'Photo',
      icon: <PhotoCamera />,
      component: <Photo onImageClick={handleImageClick} />
    },
    selfie: {
      title: 'Selfie',
      icon: <CameraAlt />,
      component: <Selfie onImageClick={handleImageClick} />
    },
    nswf: {
      title: 'NSFW',
      icon: <Block />,
      component: <Nswf onImageClick={handleImageClick} />
    },
    environment: {
      title: 'Environment',
      icon: <Accessibility />,
      component: <Environment onImageClick={handleImageClick} />
    }
  };

  return (
    <div className="l1-help">
      {/* Tabs Header */}
      <div className="l1-help__tabs">
        {Object.entries(tabs).map(([id, tab]) => (
          <button
            key={id}
            onClick={() => setActiveTab(id)}
            className={`l1-help__tab ${activeTab === id ? 'l1-help__tab--active' : ''}`}
          >
            <div className="l1-help__tab-icon">{tab.icon}</div>
            <span className="l1-help__tab-title">{tab.title}</span>
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="l1-help__content">
        {tabs[activeTab]?.component}
      </div>

      {/* Image Modal */}
      {enlargedImage && (
        <div className="image-modal" onClick={handleCloseModal}>
          <div className="image-modal__backdrop" />
          <div className="image-modal__content" onClick={(e) => e.stopPropagation()}>
            <img src={enlargedImage} alt="Enlarged" className="image-modal__image" />
            <button className="image-modal__close" onClick={handleCloseModal}>×</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default L1HELP;